<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loader -->
@if (loading) {
<div class="formLoader">
  <i class="fa fa-spinner fa-spin gt-refresh"></i>
</div>
}

<!-- App Modal Content (Apportionment Base) -->
@if (!loading && modalType === 'app') {
<div class="modal-body no-body-scroll" [hidden]="minimise">
  <!-- Base Level Radio Buttons (QBU only) -->
  @if (gridType === 'QBU') {
<div class="row form-group col-md-offset-1" style="padding:15px;">
    <label class="radio-inline">Base Level</label>
    <label class="radio-inline">
      <input type="radio" 
             [disabled]="isbaseLevelDisabled === 'disabled'" 
             name="rd_base_level" 
             id="rd_base_level_cfc" 
             value="H" 
             [(ngModel)]="BASE_LEVEL"> CFC
    </label>
    <label class="radio-inline">
      <input type="radio" 
             [disabled]="isbaseLevelDisabled === 'disabled'" 
             name="rd_base_level" 
             id="rd_base_level_qbu" 
             value="Q" 
             [(ngModel)]="BASE_LEVEL"> QBU
    </label>
  </div>
}

  <!-- Apportionment Base Dropdown -->
  <div class="row form-group col-md-5">
    <div class="col-md-12" style="display: flex; align-items: center; gap: 10px;">
      <label style="margin-bottom: 0; white-space: nowrap; min-width: 160px;"><strong>Apportionment Base</strong></label>
      <select id="appBase" 
              name="appBase" 
              class="form-control"
              [(ngModel)]="selectedAppBase"
              [compareWith]="compareAppBase"
              style="flex: 1; max-width: 300px;">
        <option [ngValue]="null">Select</option>
        @for (base of appBases; track $index) {
<option [ngValue]="base">{{base.BASE_NAME}}</option>
}
      </select>
    </div>
  </div>
  
  <!-- Issue ID Dropdown (hidden when issue tracking disabled for scenario / filters) -->
  @if (issueIdEnabled()) {
<div class="row form-group col-md-5">
    <div class="col-md-12" style="display: flex; align-items: center; gap: 10px;">
      <label style="margin-bottom: 0; white-space: nowrap; min-width: 160px;"><strong>Issue ID</strong></label>
      <select id="issue" 
              name="issue" 
              class="form-control"
              [(ngModel)]="selectedIssueId"
              [compareWith]="compareIssueId"
              style="flex: 1; max-width: 300px;">
        <option [ngValue]="null">Select Issue Id</option>
        @for (issue of appIssueId; track $index) {
<option [ngValue]="issue">{{issue.ISSUE_SHORT_DESC}}</option>
}
      </select>
      @if (app_issue_flag) {
<span class="form-error-container" style="font-size: 12px; margin-left: 10px;">Please select Issue Id</span>
}
    </div>
  </div>
}
</div>
}

<!-- Basket Modal Content (Add/Edit Basket) -->
@if (!loading && modalType === 'basket') {
<div class="modal-body no-body-scroll" [hidden]="minimise">
  <div class="col-md-12">
    <h5><strong>GHOST Amount:</strong> {{rowData.ADJUSTED_BOOK | number}}</h5>
    <h5><strong>Unsourced/Apportioned Amount:</strong> {{unsourced_amt_modal | number}}</h5>
  </div>

  @if (disableTable) {
<p class="text-danger" style="padding: 0 15px;">Unable to load baskets. Please try again.</p>
}

  <!-- Existing Baskets Table (always shown after load; empty tbody when no rows) -->
  @if (!disableTable) {
<table class="table table-bordered table-condensed table-hover boldText">
    <thead>
      <tr>
        <th [attr.colspan]="tableColspan">
          {{tableTitle}}
          <i class="fa pull-left" 
             [ngClass]="{'fa-plus-square-o': tableMinimiseAdd, 'fa-minus-square-o': !tableMinimiseAdd}" 
             style="margin-right: 10px; cursor: pointer;" 
             (click)="tableMinimiseAdd=!tableMinimiseAdd"></i>
        </th>
      </tr>
      <tr [hidden]="tableMinimiseAdd" class="plain-header-row">
        <th class="plain-header">Baskets</th>
        <th class="plain-header">Amount</th>
        @if (issueIdEnabled()) {
<th class="plain-header">Issue ID</th>
}
      </tr>
    </thead>
    <tbody [hidden]="tableMinimiseAdd">
      @for (record of basketTable; track $index; let i = $index) {
<tr>
        <!-- Basket Column -->
        <td class="basket-cell border">
          <div class="basket-column-content">{{record.BASKET_NAME}}</div>
        </td>
        
        <!-- Amount Column -->
        <td class="amount-cell border">
          <div class="amount-column-content">
            <input type="text" 
                   id="postAmount_{{i}}" 
                   name="postAmount_{{i}}" 
                   [value]="record.AMOUNT | numberWithCommas"
                   [disabled]="(issueIdEnabled() && (record.REC_TYPE === 'D' || record.ISSUE_KEY == 0))
                             || (!issueIdEnabled() && record.REC_TYPE === 'D')"
                   (input)="onAmountInput($event, record, 'AMOUNT', i)"
                   (blur)="onAmountBlur($event, record, 'AMOUNT')"
                   class="text-right form-control input-sm numText">
          </div>
        </td>
        
        <!-- Issue ID Column (if enabled) -->
        @if (issueIdEnabled()) {
<td class="issue-cell">
          <div class="issue-column-content">
            <select class="form-control" 
                    [disabled]="(issueIdEnabled() && (record.REC_TYPE == 'D' || record.ISSUE_KEY == 0)) || 
                                (!issueIdEnabled() && record.REC_TYPE == 'D')"
                    name="issue_key_{{i}}"
                    [(ngModel)]="record.ISSUE_KEY"
                    (ngModelChange)="changeIssueId(record.ISSUE_KEY, i)">
              <option value="">Select Issue ID</option>
              @for (issue of issueDropdown_edit; track $index) {
<option [value]="issue.ISSUE_ID">{{issue.ISSUE_SHORT_DESC}}</option>
}
            </select>
          </div>
        </td>
}
      </tr>
}
    </tbody>
  </table>
}

  <!-- New Baskets Table (single table with rows) -->
  @if (showNewBasketTable && objects.length > 0) {
<table class="table table-bordered table-condensed table-hover boldText" style="margin-top: 15px;">
    <thead>
      <tr>
        <th [attr.colspan]="tableColspan">
          New Baskets
          <i class="fa pull-left" 
             [ngClass]="{'fa-plus-square-o': tableMinimiseNew, 'fa-minus-square-o': !tableMinimiseNew}" 
             style="margin-right: 10px; cursor: pointer;" 
             (click)="tableMinimiseNew=!tableMinimiseNew"></i>
        </th>
      </tr>
    </thead>
    <tbody [hidden]="tableMinimiseNew">
      @for (row of objects; track $index; let i = $index) {
<tr>
        <!-- Basket Column -->
        <td class="basket-cell">
          <div class="basket-column-content">
            <label class="field-label">Baskets</label>
            <select class="form-control"
                    [(ngModel)]="row.basketDesc"
                    (ngModelChange)="changeBaskets(row.basketDesc, i)">
              <option [ngValue]="''">Select Description</option>
              @for (basket of baskets; track $index) {
<option [ngValue]="basket">{{basket.BASKET_NAME}}</option>
}
            </select>
            @if (row.basketFlag || row.issueIdFlag) {
<span class="form-error-container" [style.visibility]="row.basketFlag ? 'visible' : 'hidden'">
              @if (row.basketFlag) {
<span>Please select type of Basket</span>
}
              @if (!row.basketFlag) {
<span>&nbsp;</span>
}
            </span>
}
          </div>
        </td>
        
        <!-- Amount Column -->
        <td class="amount-cell">
          <div class="amount-column-content">
            <label class="field-label">Amount</label>
            <input type="text" 
                   id="BasketAmount_{{i}}" 
                   name="BasketAmount_{{i}}" 
                   [value]="row.basketAmount | numberWithCommas"
                   (input)="onAmountInput($event, row, 'basketAmount', i)"
                   (blur)="onAmountBlur($event, row, 'basketAmount')"
                   class="text-right form-control input-sm numText">
            @if (row.basketFlag || row.issueIdFlag) {
<span class="form-error-container" style="visibility: hidden;">&nbsp;</span>
}
          </div>
        </td>
        
        <!-- Issue ID Column (if enabled) -->
        @if (issueIdEnabled()) {
<td class="issue-cell">
          <div class="issue-column-content">
            <label class="field-label">Issue ID</label>
            <select class="form-control"
                    [(ngModel)]="row.issueId"
                    (ngModelChange)="changeEditIssueId(row.issueId, i)">
              <option [ngValue]="null">Select Issue ID</option>
              @for (issue of issueDropdown; track $index) {
<option [ngValue]="issue">{{issue.ISSUE_SHORT_DESC}}</option>
}
            </select>
            @if (row.issueIdFlag) {
<span class="form-error-container">Please select Issue Id</span>
}
            @if (row.basketFlag && !row.issueIdFlag) {
<span class="form-error-container" style="visibility: hidden;">&nbsp;</span>
}
          </div>
        </td>
}
      </tr>
}
    </tbody>
  </table>
}
</div>
}

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  <!-- App Modal Buttons -->
  @if (modalType === 'app') {
<div>
    <button class="save-button"  
            type="button"  
            [disabled]="isSaveClicked || hasServiceError"  
            (click)="saveApportionmentBase()"> 
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}{{labelSaveAndUpdate}}
    </button>
    <button class="reset-button"  
            type="button"  
            [disabled]="hasServiceError"
            (click)="reset()">{{labelReset}}</button>
    <button class="cancel-button"  
            type="button"  
            [disabled]="hasServiceError"
            (click)="cancel()">{{labelCancel}}</button>
  </div>
}

  <!-- Basket Modal Buttons -->
  @if (modalType === 'basket') {
<div class="basket-footer-buttons">
    <div class="footer-buttons-left">
      <button class="save-button"  
              type="button"
              [disabled]="hasServiceError"
              (click)="addNew()">
      Add New Basket
      </button>
    </div>
    <div class="footer-buttons-right">
      <button class="save-button"  
              type="button"  
              [disabled]="isSaveClicked || hasServiceError"  
              (click)="singleRowSave()"> 
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
      </button>
      <button class="cancel-button"  
              type="button"  
              [disabled]="hasServiceError"
              (click)="cancel()">{{labelCancel}}</button>
    </div>
  </div>
}
</div>
